// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-components-templates-people-js" + "-" + "a27377b634e2f3769d33" + ".js";
};